import clsx from 'clsx'
import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react'

type FieldProps = {
  label: string
  error?: string
  as?: 'input' | 'textarea' | 'select'
} & InputHTMLAttributes<HTMLInputElement> &
  TextareaHTMLAttributes<HTMLTextAreaElement> &
  SelectHTMLAttributes<HTMLSelectElement>

export function Field({ label, error, as = 'input', ...props }: FieldProps) {
  const className = clsx(
    'mt-2 w-full rounded-lg border bg-white px-3 py-2.5 text-sm text-stone-900 outline-none transition focus:border-mango-orange focus:ring-4 focus:ring-mango-yellow/25',
    error ? 'border-red-300' : 'border-stone-200',
    props.className,
  )

  return (
    <label className="block text-sm font-semibold text-leaf-dark">
      {label}
      {as === 'textarea' ? (
        <textarea {...props} className={className} rows={4} />
      ) : as === 'select' ? (
        <select {...props} className={className} />
      ) : (
        <input {...props} className={className} />
      )}
      {error ? <p className="mt-1 text-xs font-medium text-red-600">{error}</p> : null}
    </label>
  )
}
